<template>
  <!-- <div class="shop">订单详情</div> -->

  <div class="shop" v-loading="loading">
    <span class="title">订单基本信息</span>

    <el-button
      type="primary"
      size="mini"
      @click="closeOrder"
      v-show="order_detail.order_status === 0"
      >关闭订单</el-button
    >
    <!-- 订单基本信息 -->
    <el-table
      :data="baseData"
      style="width:100%"
      max-height="600"
      border
      class="infotable"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column label="订单编号" prop="order_sn"></el-table-column>
      <el-table-column label="用户账号" prop="user_mobile"></el-table-column>
      <el-table-column
        label="创建时间"
        prop="create_order_time"
      ></el-table-column>
      <el-table-column label="订单原价" prop="original_price"></el-table-column>
      <el-table-column label="订单状态" prop="order_status_name">
      </el-table-column>
    </el-table>
    <!--  -->

    <span class="title">订单商品信息</span>
    <!-- 订单商品信息 -->
    <el-table
      :data="goodData"
      style="width:100%"
      max-height="610"
      border
      class="infotable"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column label="商品名称" prop="goods_name"></el-table-column>
      <el-table-column label="红包抵扣" prop="total_fee"> </el-table-column>
    </el-table>
    <!--  -->

    <span class="title">商家信息</span>
    <el-table
      :data="shopData"
      style="width:100%"
      max-height="610"
      border
      class="infotable"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column label="商家账号" prop="store_mobile"></el-table-column>
      <el-table-column label="店铺地址" prop="shop_address"></el-table-column>
    </el-table>

    <!--关闭订单备注-->
    <jdialog
      title="关闭订单备注"
      :visible.sync="isCloseOrderremark"
      width="640px"
    >
      <div class="remark">
        <p class="note">
          提示：关闭订单后，资金会原路返还给用户，请确认无误后操作
        </p>
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          label-width="140px"
          class="demo-ruleForm"
        >
          <el-form-item label="输入密码：" prop="code">
            <el-input
              size="mini"
              v-model="form.code"
              type="password"
              style="width:120px;"
            ></el-input>
          </el-form-item>
          <el-form-item label="操作备注：" prop="remark">
            <el-input
              size="mini"
              v-model="form.remark"
              placeholder="请输入操作备注"
              type="textarea"
              row="4"
            ></el-input>
          </el-form-item>
        </el-form>

        <div class="btn-info">
          <el-button size="mini" @click="isCloseOrderremark = false"
            >取消</el-button
          >
          <el-button size="mini" type="primary" @click="centerorderInfo"
            >确定</el-button
          >
        </div>
      </div>
    </jdialog>
  </div>
</template>

<script>
import errorImg from '@/assets/images/error_img.png'
import { freeOrderDetailGet, closeFreeOrder } from '@/api/autarky'
export default {
  data() {
    return {
      order_no: '',
      errorImg,
      isCloseOrderremark: false,
      order_detail: {},
      baseData: [],
      goodData: [],
      shopData: [],
      form: {
        order_id: '',
        remark: '',
        code: ''
      },
      loading: true,
      rules: {
        remark: [{ required: true, message: '请输入操作备注', trigger: 'blur' }],
        code: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },

      //物流详情
      isShowWoodsDetailInfo: false,
      woodActivities: [],
      wood_log_num: '773016201880275'
    }
  },
  created() {
    this.order_no = this.$route.query.order_no
    //获取订单详情数据
    if (this.order_no) {
      this.getorderDetailGetData()
    }
  },
  mounted() {},
  methods: {
    //关闭订单
    closeOrder() {
      // if (this.profitInfoData.length == 0) {
      //   this.form.price = 0
      // } else {
      //   this.form.price = this.profitInfoData[0].final_price
      // }
      this.form.order_id = this.order_detail.order_id
      this.isCloseOrderremark = true
    },

    centerorderInfo() {
       if (!this.form.code) {
        this.$message.error('请输入密码')
        return
      }
      if (!this.form.remark) {
        this.$message.error('请填写备注')
        return
      }
      this.getcloseOrderUpdateData()
    },

    //获取订单详情数据
    async getorderDetailGetData() {
      let res = await freeOrderDetailGet(this.order_no)
      if (res.code === 10000) {
        this.order_detail = res.data
        this.baseData.push({
          order_sn: res.data.order_sn,
          user_mobile: res.data.user_mobile,
          create_order_time: res.data.create_order_time,
          original_price: res.data.original_price,
          order_status_name: res.data.order_status_name
        })
        this.goodData.push({
          goods_name: res.data.goods_name,
          total_fee: res.data.total_fee
        })
        this.shopData.push({
          store_mobile: res.data.store_mobile,
          shop_address: res.data.shop_address
        })
        this.loading = false
      } else {
        this.$message.error(res.message)
        this.loading = false
      }
    },

    //关闭订单
    async getcloseOrderUpdateData() {
      let res = await closeFreeOrder(this.form)
      if (res.code === 10000) {
        this.$message.success(res.message)
        this.baseData = []
        this.goodData = []
        this.shopData = []
        this.getorderDetailGetData()
        ;(this.form = {
          order_id: '',
          remark: '',
          code: ''
        }),
          (this.isCloseOrderremark = false)
      } else {
        this.$message.error(res.message)
      }
    },

    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    }
  }
}
</script>
<style lang="scss" scoped>
.shop {
  padding: 20px;

  .title {
    color: #333333;
    font-size: 18px;
    margin-right: 12px;
    margin-top: 4px;
  }
  .status {
    color: #f4222d;
  }
  .loginfor {
    cursor: pointer;
  }
  .infotable {
    margin: 20px 0;
  }

  .remark {
    padding: 20px;
    .note {
      color: #666666;
      margin-bottom: 12px;
    }
    .btn-info {
      text-align: center;
    }
  }
  .block {
    padding: 20px;
  }
}
</style>
